<template>
  <div>
    <div class="form-group">
      <label class="control-label">Help URL</label>

      <input
        type="text"
        class="form-control"
        v-model="stateProgramHelpUrl"
        v-validate="{url: {require_protocol: true }}"
        name="help_url"
        data-vv-as="Help Url"
        data-vv-delay="500"
        data-vv-validate-on="change|input"
      >

      <help-block field="help_url"/>
    </div>

    <div class="text-right">
      <ladda-button
        type="button"
        class="btn btn-success btn-publish-program"
        :validate="false"
        :click="save"
      >Save</ladda-button>
    </div>
  </div>
</template>

<script>
import { programMethods, programComputed } from 'vx/helpers'
import { stateMapper } from 'mixins/programs'
import { forIn, each } from 'lodash'

export default {
  mixins: [stateMapper],

  computed: {
    ...programComputed
  },

  methods: {
    ...programMethods,

    async save () {
      if (this.errors.items.length > 0) {
        return
      }
      this.$validator.reset()
      await this.updateProgramHelpUrl({ program: this.program, payload: { help_url: this.stateProgramHelpUrl } }).then((response) => {
        this.$noty.success('Program help url updated successfully.')
      }).catch((error) => {
        this.$noty.error('An error occured while updating the Program help url.')
        if (error.response && error.response.status === 422) {
          this.renderServerErrors(error.response)
        }
      })
    },
    renderServerErrors (response) {
      forIn(response.data.errors, (errors, name) => {
        let scope
        let field

        if (name.indexOf('.') !== -1) {
          scope = `placement-${name.split('.')[1]}`

          field = this.$validator.fields.find({ name: name.split('.').pop(), scope })
        } else {
          scope = null

          field = this.$validator.fields.find({ name })
        }

        field.setFlags({ invalid: true, valid: false, validated: true })

        each(errors, (msg) => {
          this.errors.add({ field: field.name, id: field.id, msg, scope })
        })
      })
    }
  }
}
</script>
